export class PetProblemModel {
    problem_no: number
    pet_no: number
    diagnosisId: number 
    start_date: any
    last_send_date: any
    status: number
    datedesc: string
    noteseqno: number
    PreferredTerm?: string
    OtherTerm?:string
    ModuleID?:number
    EffectiveTime?: any


    constructor(
        problem_no: number,
        pet_no: number,
        diagnosisId: number, 
        start_date: any,
        last_send_date: any,
        status: number,
        datedesc: string,
        noteseqno: number,
        PreferredTerm?: string,
        OtherTerm?:string,
        ModuleID?:number,
        EffectiveTime?: any

    ) {
        this.problem_no = problem_no
        this.pet_no = pet_no
        this.diagnosisId = diagnosisId 
        this.start_date = start_date
        this.last_send_date = last_send_date
        this.status = status
        this.datedesc = datedesc
        this.noteseqno = noteseqno
        this.PreferredTerm = PreferredTerm
        this.OtherTerm = OtherTerm
        this.ModuleID = ModuleID
        this.EffectiveTime = EffectiveTime 
    }
}